import { Controller } from '@hotwired/stimulus';
import Tooltip from 'bootstrap/js/dist/tooltip.js';

// Connects to data-controller="tooltip"
export default class extends Controller {
  static values = {
    sanitize: { type: Boolean, default: true },
  };

  connect() {
    new Tooltip(this.element, {
      animation: false,
      placement: 'right',
      container: 'body',
      delay: { show: 0, hide: 700 },
      html: true,
      sanitize: this.sanitizeValue,
    });
  }
}
